import { Space, Tag, Typography } from 'antd'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { queryKeys } from '@/shared/api/queryKeys'
import { usePermissions } from '@/shared/auth/usePermissions'
import { shortId } from '@/shared/lib/shortId'
import { fetchAgent } from '@/features/agent/agentApi'
import { fetchSubscriber } from '@/features/subscriber/subscriberApi'

const AGENT_TYPES = ['AGENT', 'RESELLER']

export function LedgerOwnerName({ type, id }: { type: string; id: string }) {
  const { t } = useTranslation()
  const { can } = usePermissions()
  const isSubscriber = type === 'SUBSCRIBER'
  const isAgent = AGENT_TYPES.includes(type)

  const subscriber = useQuery({
    queryKey: queryKeys.subscribers.detail(id),
    queryFn: () => fetchSubscriber(id),
    enabled: isSubscriber && can('subscriber.read'),
    staleTime: 5 * 60_000,
    retry: false,
  })

  const agent = useQuery({
    queryKey: queryKeys.agents.detail(id),
    queryFn: () => fetchAgent(id),
    enabled: isAgent && can('agent.read'),
    staleTime: 5 * 60_000,
    retry: false,
  })

  const name = subscriber.data ? (
    <Link to={`/subscribers/${id}`} onClick={(event) => event.stopPropagation()}>
      {subscriber.data.login}
    </Link>
  ) : agent.data ? (
    <Typography.Text>{agent.data.displayName}</Typography.Text>
  ) : type === 'TENANT' ? null : (
    <Typography.Text code copyable={{ text: id }} style={{ fontSize: 12 }}>
      {shortId(id)}
    </Typography.Text>
  )

  return (
    <Space size={4} wrap>
      <Tag>{t(`ledgerOwnerType.${type}`, { defaultValue: type })}</Tag>
      {name}
    </Space>
  )
}
